import fetchData from './fetchData';

function videoDownload() {

	const links = document.querySelectorAll('[data-video-download]');
	if (links) {
		links.forEach(link => {
			link.addEventListener('click', function() {
				let webinarId = link.dataset.videoDownload,
					url = '/ajax/?controller=webinars&action=saveEndWebinar',
					data = {
						webinarId: webinarId,
						isChecked: true
					},
					options = {
						headers: {
							'Content-Type': 'application/json'
		
						},
						body: JSON.stringify(data)
					};
				
				fetchData(url, options).
					then(result => {
						// console.log(result);
						if (!result.status) {
							let message = ``;
							for (let key in result.globalMessage) {
								message += result.globalMessage[key] + `<br>`;

							}
							// console.log(message);
							alert(message);

						} else {
							return;
						}

					})			

			})

		})

	}

			

}


export default videoDownload;